module.exports = __webpack_public_path__ + "img/container-orange.4993e2d7.svg";